module.exports = __webpack_public_path__ + "branches-search-bg.35feee4c0eeb8ad1f360.jpg";


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/assets/ra/img/branches-search-bg.jpg
// module id = ../../../../../assets/ra/img/branches-search-bg.jpg
// module chunks = main